import React from "react";
import { MwInputText } from "../../ui";
import { useTranslation } from "react-i18next";

const AdvancedForm = ({ errors, accountNo, setAccountNo, vatNo, setVatNo, limitCredit, setLimitCredit }) => {
  const [t] = useTranslation("global");
  return (
    <>
      <div className="py-2">
        <MwInputText label={t("vendors.taxNumber")} id="vatNo" value={vatNo} onChange={(e) => setVatNo(e.target.value)} />
      </div>
      <div className="py-2">
        <MwInputText label={t("vendors.accountNumber")} id="accountNo" value={accountNo} onChange={(e) => setAccountNo(e.target.value)} />
      </div>
      <div className="py-2">
        <MwInputText
          label={t("vendors.creditLimit")}
          id="limitCredit"
          inputType="Number"
          value={limitCredit}
          invalid={!!errors.limitCredit}
          invalidMsg={errors.limitCredit}
          onChange={(e) => setLimitCredit(e.target.value)}
        />
      </div>
    </>
  );
};

export default AdvancedForm;

